import { get_attribute_value } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/attributes.js?1733898722641';

export function get_badges(product) {
    const badges = [];
    const price = get_attribute_value(product, 'price') ? Number.parseFloat(get_attribute_value(product, 'price')) : undefined;
    const finalPrice = product.final_price;
    // obsolete
    if (product?.new?.value === '1') {
        badges.push({
            name: 'New',
            class: ''
        });
    }
    if (finalPrice && price && finalPrice < price) {
        badges.push({
            name: 'Sale',
            class: 'm-product-badge__sale'
        });
    }
    if (product?.is_bestseller === '1') {
        badges.push({
            name: 'Bestseller',
            class: 'm-product-badge__bestseller'
        });
    }
    if (product?.is_vegan === '1') {
        badges.push({
            name: 'Vegan',
            class: 'm-product-badge__vegan'
        });
    }
    if (product?.kw_sustainable?.value === '1') {
        badges.push({
            name: 'Nachhaltig',
            class: 'm-product-badge__sustainable'
        });
    }
    return badges;
}
